"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const themes_1 = require("../../themes");
const background = {
    bgcolor: '#2C384B',
    paddingY: themes_1.Spacings.medium2,
};
const navigation = {
    display: 'grid',
    gridAutoFlow: { sm: 'column' },
    columnGap: { sm: themes_1.Spacings.small4, md: themes_1.Spacings.medium2 },
    justifyItems: { sm: 'center', md: 'normal' },
    marginBottom: {
        xs: themes_1.Spacings.medium4,
        sm: themes_1.Spacings.medium2,
        md: 0,
    },
};
exports.default = {
    background,
    navigation,
};
